import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// Link
import { Link } from "react-router-dom";

// @material-ui/icons
import School from "@material-ui/icons/School";
import Explore from "@material-ui/icons/Explore";
import ViewCarousel from "@material-ui/icons/ViewCarousel";
import PlayArrow from "@material-ui/icons/PlayArrow";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import Button from "components/CustomButtons/Button.jsx";

import journeyStyle from "assets/jss/material-kit-pro-react/views/portalPageSections/journeyStyle.jsx";

class JourneySection extends React.Component {
  render() {
    const { classes } = this.props;
    const typeformLink = process.env.REACT_APP_TYPEFORM_ID
      ? process.env.REACT_APP_TYPEFORM_ID
      : "https://capabilityexplorer.typeform.com/to/SCt0jP";
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>
              Your learning hub for
              <br />
              Teaching Excellence at Navitas
            </h2>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer style={{ paddingBottom: "100px" }}>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Capability Explorer"
                icon={Explore}
                iconColor="info"
                vertical
              />
              <a href={typeformLink} target="_blank" rel="noopener noreferrer">
                <Button style={{ width: "60%" }} type="button" color="info">
                  <PlayArrow />
                  Launch
                </Button>
              </a>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="PD Catalogue"
                icon={ViewCarousel}
                iconColor="rose"
                vertical
              />
              <Link to={"/catalogue"}>
                <Button style={{ width: "60%" }} type="button" color="rose">
                  <PlayArrow />
                  Explore
                </Button>
              </Link>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Already enrolled in PD"
                icon={School}
                iconColor="gray"
                vertical
              />
              <a
                rel="noopener noreferrer"
                href="https://learning.ten.navitas.com"
                target="_blank"
              >
                <Button style={{ width: "60%" }} type="button" color="gray">
                  <PlayArrow />
                  Login to Moodle
                </Button>
              </a>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(journeyStyle)(JourneySection);
